import { $ } from '@starberry/components';
import AuthServices from 'core/services/store/auth/services';
import * as AuthActions from 'core/services/store/auth/actions';

import { Routes } from '../../routes';

export default {
  $: 'Dashboard',
  title: 'Profile',
  titleProps: {
    d: 'none',
  },
  content: [
    { $: 'ProfileHero' },
    {
      $: 'Flex',
      children: [
        {
          $: 'SimpleTabs',
          provide: ['userprofile', 'auth'],
          props: {
            flex: 1,
            onChange: (_, context) => (index) => {
              if (index === 3) {
                const [, dispatch] = context?.state?.auth || [];
                AuthServices(dispatch, AuthActions).logout();
                window.location = Routes.LoginPage;
              } else {
                const [, dispatch] = context?.state?.userprofile || [];
                dispatch({ type: 'RESET_MESSAGE' });
              }
            },
          },
          sidecontent: {
            $: 'Flex',
            props: {
              alignContent: 'flex-start',
              justifyContent: 'flex-start',
              flexGrow: 0,
            },
            // children: {
            //   $: 'ValuationCard',
            //   props: { mt: 20, mr: $('theme.space.12') },
            // },
          },
          tabs: [
            {
              title: 'Personal Details',
              id: 'personal-details',
              content: { $: 'ProfileForm' },
            },
            {
              title: 'Notification Preferences',
              id: 'notification-preferences',
              content: { $: 'NotificationPreferences' },
            },
            {
              title: 'Change Password',
              id: 'change-password',
              content: { $: 'ChangePasswordForm' },
            },
            {
              title: 'Logout',
              content: { $: 'Flex' },
            },
          ],
        },
      ],
    },
  ],
};
